(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var roots = document.querySelectorAll('[data-cvk-root]');
    roots.forEach(function (root) {
      new CollectionVik(root);
    });
    document.querySelectorAll('[data-cvk-grid-container]').forEach(function (grid) {
      if (grid.closest('[data-cvk-root]')) return;
      grid.addEventListener('click', onStandaloneGridClick);
    });
    drawerMenuInit();
  }

  function onStandaloneGridClick(e) {
    var addBtn = e.target.closest('[data-cvk-add-to-cart]');
    if (!addBtn || addBtn.disabled) return;
    CollectionVik.prototype.addToCart(addBtn);
  }

  function CollectionVik(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.baseUrl = root.getAttribute('data-url');
    this.filtersContainer = root.querySelector('[data-cvk-filters-container]');
    this.gridContainer = root.querySelector('[data-cvk-grid-container]');
    this.debounceTimer = null;

    this.bindFilters();
    this.bindGrid();
    document.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  function drawerMenuInit() {
    const button = document.querySelector('.cvk-button-mobile');
    const backdrop = document.querySelector('.cvk-filters-backdrop');
    const filters = document.querySelector('.cvk-filters');

    if (button && backdrop && filters) {
      button.addEventListener('click', () => {
        filters.classList.add('open');
        backdrop.classList.add('open');
      });

      backdrop.addEventListener('click', () => {
        filters.classList.remove('open');
        backdrop.classList.remove('open');
      });
    }
  };


  CollectionVik.prototype.bindFilters = function () {
    var self = this;
    var form = this.filtersContainer.querySelector('[data-cvk-filters-form]');
    if (!form) return;

    this.filtersContainer.querySelectorAll('[data-cvk-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var filterEl = btn.closest('[data-cvk-filter]');
        var isOpen = filterEl.classList.contains('is-open');

        if (!isOpen) {
          filterEl.classList.add('is-open');
          filterEl.querySelector('[data-cvk-filter-panel]').hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        } else {
          filterEl.classList.remove('is-open');
          filterEl.querySelector('[data-cvk-filter-panel]').hidden = true;
          filterEl.querySelector('[data-cvk-filter-toggle]').setAttribute('aria-expanded', 'false');
        }
      });
    });

    this.filtersContainer.querySelectorAll('[data-cvk-filter-input]').forEach(function (input) {
      var eventName = input.type === 'number' ? 'input' : 'change';
      var noSelfApply = input.hasAttribute('data-cvk-no-self-apply');
      if (noSelfApply) return;
      input.addEventListener(eventName, function () {
        if (input.type === 'number') {
          clearTimeout(self.debounceTimer);
          self.debounceTimer = setTimeout(function () {
            self.applyFilters();
          }, 500);
        } else {
          self.applyFilters();
        }
      });
    });

    this.filtersContainer.querySelectorAll('[data-cvk-filter-apply]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.applyFilters();
      });
    });

    this.filtersContainer.querySelectorAll('[data-cvk-filter-clear]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filterEl = btn.closest('[data-cvk-filter]');
        filterEl.querySelectorAll('[data-cvk-filter-input]').forEach(function (input) {
          if (input.type === 'checkbox') input.checked = false;
          else input.value = '';
        });
        self.applyFilters();
      });
    });
  };

  CollectionVik.prototype.bindGrid = function () {
    var self = this;

    this.gridContainer.addEventListener('click', function (e) {
      var pageLink = e.target.closest('[data-cvk-page-link]');
      if (pageLink) {
        e.preventDefault();
        self.fetchAndRender(pageLink.getAttribute('href'));
        return;
      }

      var addBtn = e.target.closest('[data-cvk-add-to-cart]');
      if (addBtn) {
        self.addToCart(addBtn);
      }
    });
  };

  CollectionVik.prototype.handleOutsideClick = function (e) {
    if (!this.filtersContainer.contains(e.target)) {
      this.filtersContainer.querySelectorAll('[data-cvk-filter]').forEach(function (f) {
        f.classList.remove('is-open');
        f.querySelector('[data-cvk-filter-panel]').hidden = true;
        f.querySelector('[data-cvk-filter-toggle]').setAttribute('aria-expanded', 'false');
      });
    }
  };

  CollectionVik.prototype.applyFilters = function () {
    var form = this.filtersContainer.querySelector('[data-cvk-filters-form]');
    var params = new URLSearchParams();

    var inputs = form.querySelectorAll('[data-cvk-filter-input]');
    inputs.forEach(function (input) {
      if (input.type === 'checkbox') {
        if (input.checked) params.append(input.name, input.value);
      } else if (input.type === 'number') {
        if (input.value !== '') params.append(input.name, input.value);
      }
    });

    var url = this.baseUrl + (params.toString() ? '?' + params.toString() : '');
    this.fetchAndRender(url);
  };

  CollectionVik.prototype.fetchAndRender = function (url) {
    var self = this;
    var grid = this.gridContainer.querySelector('[data-cvk-grid]');
    if (grid) grid.classList.add('is-loading');

    var sectionUrl = this.appendSectionId(url);

    fetch(sectionUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newFilters = doc.querySelector('[data-cvk-filters-container]');
        var newGrid = doc.querySelector('[data-cvk-grid-container]');

        if (newFilters) {
          self.filtersContainer.innerHTML = newFilters.innerHTML;
          self.bindFilters();
        }
        if (newGrid) {
          self.gridContainer.innerHTML = newGrid.innerHTML;
        }

        const urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.set('view', 'linhas');
        window.history.pushState({}, '', urlObj.toString());
        self.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        drawerMenuInit();
      })
      .catch(function (err) {
        console.error('Erro ao atualizar produtos:', err);
        if (grid) grid.classList.remove('is-loading');
      });
  };

  CollectionVik.prototype.appendSectionId = function (url) {
    var separator = url.indexOf('?') > -1 ? '&' : '?';
    return url + separator + 'section_id=' + this.sectionId;
  };

  CollectionVik.prototype.addToCart = function (btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalEl = btn.querySelector("span");

    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Erro ao adicionar ao carrinho');
        return response.json();
      })
      .then(function () {
        btn.setAttribute('adicionado', 'true');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (typeof window.refreshCart === 'function') {
          window.refreshCart(null, { openMinicart: false });
        } else if (typeof window.updateCartCounters === 'function') {
          window.updateCartCounters();
        }
        setTimeout(function () {
          btn.removeAttribute('adicionado');
          btn.disabled = false;
        }, 1500);
      })
      .catch(function (err) {
        console.error(err);
        setTimeout(function () {
          btn.removeAttribute('adicionado');
          btn.disabled = false;
        }, 1500);
      });
  };
})();
